export default function updateProperties(
    {properties}: UpdateAreaPointPropertiesAction,
    setAreas: SetState<{[localId: string]: Area}>
) {
    const {localId, areaLocalId} = properties;

    setAreas((latestAreas) => {
        const latestArea = latestAreas[areaLocalId];
        if (!(latestArea.isGeometryLoaded && latestArea.isGeometryEditable)) throw new Error();
        const latestAreaPoint = latestArea.points[localId];

        return {
            ...latestAreas,
            [areaLocalId]: {
                ...latestArea,
                points: {
                    ...latestArea.points,
                    [localId]: {
                        ...latestAreaPoint,
                        properties: {
                            ...latestAreaPoint.properties,
                            ...properties,
                        },
                    },
                },
            },
        };
    });

    return [localId];
}
